<template>
      <div
        class="imbee-bubble-close-cross"
        v-bind:style="{
          color,
          backgroundColor,
          fontWeight,
          height: size,
          width: size,
          top,
          right,
        }"
        v-if="show && !opened && !showCta"
        @click.prevent.stop="crossClicked"

      >
        <span
          class="remove-bot"
          id="remove-bot"
          v-bind:style="{
            fontSize
          }"
          >
          <svg data-v-bd4127ec="" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 32 32" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path data-v-bd4127ec="" d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"></path></svg>
        </span
        >
      </div>
  </template>
  
  <script>
  export default {
    name: "CloseCross",
    props: {
      opened: { type: Boolean, default: false },
      show: { type: Boolean },

      color: { type: String },
      backgroundColor: { type: String },
      fontSize: { type: String },
      fontWeight: { type: String },
      showCta: { type: Boolean, default: false },
      size: { type: String },
      top: { type: String },
      right: { type: String },
    },
    methods: {
      crossClicked() {

        // Asegúrate de detener la propagación
        event.stopPropagation();
        event.preventDefault();
        
        // Emitir un evento al componente padre para cerrarlo
        this.$emit('crossclicked');

      }
    }
  };
  </script>
  
  <style scoped>
    .imbee-bubble-close-cross {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        box-sizing: border-box;
        user-select: none;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        padding: 3px 8px;
        text-align: center;
        justify-content: center;
        align-items: center;
        font-family: "Arial";
        line-height: 1.2;
        position: absolute;
        border-radius: 60%;
        -webkit-border-radius: 60%;
        -moz-border-radius: 60%;
        -ms-border-radius: 60%;
        font-size: 20px !important;
        -o-border-radius: 60%;
        white-space: nowrap;
    }

    .imbee-bubble-close-cross > span {
        display: -webkit-box; 
        display: -moz-box; 
        display: -ms-flexbox; 
        display: -webkit-flex; 
        display: flex; 
    }
  </style>


// WEBPACK FOOTER //
// CloseCross.vue?2fec0d41